// Match the federal scope used by the official contract renderer.
export function contractFee(caseType, current = 'Fee USCIS') {
  const federal = String(caseType || '').split(/[|,]/).some(value =>
    ['otro_civil', 'habeas_corpus', 'mandamus_federal', 'administrative_procedure_act_apa', 'apa_mandamus'].includes(value.trim()));
  return federal && current === 'Fee USCIS' ? 'Fee Corte Federal' : current;
}
